import React, { useContext } from 'react'
import { SkyInformationPopover } from './SkyPopover'
import {
  FirebaseService,
  FirebaseConfigKey,
} from '../../../services/FirebaseService'
import {
  InsurancePurchaseContextStore,
  INSURANCE_CONTEXT_ACTIONS,
} from '../../../context/InsuracePurchaseContext'
import {
  PolicyHullExtensionContextStore,
  ACTIONS,
} from '../../../context/PolicyHullExtensionContext'
import { useLocation, useParams } from 'react-router-dom'
import { InsuranceBillingPeriod } from '../../../models/insurance-models/InsuranceBillingPeriodModel'
var classNames = require('classnames')

export const MedicalExpensesPopover = (props) => {
  const location = useLocation()
  const insurancePurchaseContext = useContext(InsurancePurchaseContextStore)

  return (
    <SkyInformationPopover eventId={'medical-expenses'}>
      <div className="text-small">
        {' '}
        - Pays all reasonable medical expenses incurred for each person who
        sustains bodily injury provided the UAS is being used by the insured
      </div>
      <div className="text-small">
        {' '}
        - Standard SkyWatch.AI policies include{' '}
        {FirebaseService.getValue(FirebaseConfigKey.CURRENCY_SYMBOL)}500 in
        medical expenses. You can increase this coverage for an additional
        premium
      </div>
    </SkyInformationPopover>
  )
}
